import { useQuery } from '@tanstack/react-query'

import { ApiError } from '@/lib/apiErrors'
import { toI18nKey } from '@/lib/toI18nKey'
import { getMenuItems } from '@/shared/api/menu'

export function useMenuItems(ref: string, scheduleId: string) {
	const query = useQuery({
		queryKey: ['menu', 'items', ref, scheduleId],
		queryFn: () => getMenuItems(ref, scheduleId),
		enabled: ref !== '' && scheduleId !== '',
	})

	const errorKey =
		query.error != null
			? toI18nKey('olo:menu', query.error instanceof ApiError ? query.error.code : 'UNKNOWN')
			: null

	return { ...query, errorKey }
}
